import Vue from 'vue'
import App from './App.vue'

// import App2 from './App2.vue'
import i18n from "./i18n";

import store from './store'


Vue.config.productionTip = false

i18n.locale = 'en'

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#hidden-champions-container')
